import { Injectable } from '@angular/core';
import { APIResponse } from '@mommy/models/Comm.model';
import { PostCommentInfo } from '@mommy/models/PostCommentInfo.model';
import { Api } from '@mommy/services/api';

@Injectable({
  providedIn: 'root',
})
export class MemberPostCommentService {
  constructor(private api: Api) {}

  get_list(data?: any): Promise<any> {
    const endpoint = 'v1/member/member-post-comment';

    return new Promise(async (resolve, reject) => {
      try {
        const result: APIResponse = await (<any>(
          this.api.get(endpoint).toPromise()
        ));
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        console.error('member-post-comment list get error', error);
        reject(error);
      }
    });
  }

  delete(post_comment_id: number): Promise<any> {
    const endpoint = `v1/member/member-post-comment/comments/${post_comment_id}`;

    return new Promise(async (resolve, reject) => {
      try {
        const result: APIResponse = await (<any>(
          this.api.delete(endpoint).toPromise()
        ));
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        console.error('member-post-comment delete error', error);
        reject(error);
      }
    });
  }

  add(postCommentInfo: PostCommentInfo): Promise<any> {
    const endpoint = `v1/member/member-post-comment/comments`;

    return new Promise(async (resolve, reject) => {
      try {
        let params: any = {};
        params = postCommentInfo;

        const result: APIResponse = await (<any>(
          this.api.post(endpoint, params).toPromise()
        ));
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        console.error('member-post-comment add error', error);
        reject(error);
      }
    });
  }

  update(postCommentInfo: PostCommentInfo): Promise<any> {
    const endpoint = `v1/member/member-post-comment/comments/${postCommentInfo.post_comment_id}`;

    return new Promise(async (resolve, reject) => {
      try {
        const result: APIResponse = await (<any>(
          this.api.put(endpoint, postCommentInfo).toPromise()
        ));
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        console.error('member-post-comment update error', error);
        reject(error);
      }
    });
  }
}
